export const theme = {
    colors: {
      primary: "#E32223",
      secondary: "#FEC007",
      light: "#fff",
      dark: "#000000",
      gray: "#EFEFEF",
      darkerGray: "#DEDEDE",
      body: "#323030",
      footer: "#818181",
      paginationGray: "#98999F",
    },
    fonts: {
      main: '"Proxima Nova", sans-serif',
      altFont: '"Bitter", serif',
    },
  }
  const size = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1440,
  }
  export const device = {
    sm: `(min-width: ${size.sm}px)`,
    md: `(min-width: ${size.md}px)`,
    lg: `(min-width: ${size.lg}px)`,
    xl: `(min-width: ${size.xl}px)`,
    xxl: `(min-width: ${size.xxl}px)`,
    max_sm: `(max-width: ${size.sm}px)`,
    max_md: `(max-width: ${size.md}px)`,
    max_lg: `(max-width: ${size.lg}px)`,
    max_xl: `(max-width: ${size.xl}px)`,
    max_xxl: `(max-width: ${size.xxl}px)`,
  }